export default __webpack_public_path__ + "static/1-1eb8644ad368a8953333ed2f20aa204b.png";